import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import CRMSelector from '../../../components/ProfilePage/CRMSelector';
import { Api } from '../../../typings/api';

interface CRMSelectorContainerProps {
	onChange: (crmProvider: Api.CRMProviders) => void;
}

const mapStateToProps = (state: StoreState, ownProps: CRMSelectorContainerProps) => {
	const {
		profile: { crmProviders, role },
	} = state;

	return {
		...ownProps,
		crmProviders,
		isUser: role === Api.CustomerContextRoles.ROLE_APPLICATION_USER,
	};
};

export default connect(mapStateToProps)(CRMSelector);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/CRMSelector/index.tsx